import React, { useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import { TimelineLite } from 'gsap'

const BarBlock = (props) => {
    const barRef = useRef(null)
    const textRef = useRef(null)

    useEffect(() => {
        const tl = new TimelineLite()
        tl.to(barRef.current, 0.5, { width: `${props.width}%`, ease: Power1.easeOut })
        tl.to(textRef.current, 0.5, { opacity: 1 }, 0)
    }, [props.width])

    const stripHtml = htmlString => {
        return htmlString.replace(/<[^>]*>?/gm, '')
    }

    return (
        <div className='bar-block'>
            <div
                className='bar-title'
                title={stripHtml(props.title)}
                dangerouslySetInnerHTML={{ __html: props.title }}
            />
            <div className='bar-wrapper'>
                <div ref={barRef} className='bar-item' style={{ width: '0' }}>
                    <span ref={textRef} style={{ opacity: '0' }}>{props.width > 5 ? props.count : ''}</span>
                </div>
                {props.width <= 5 ? <div ref={textRef} style={{ opacity: '0' }} className='ml-2'>{props.count}</div> : ''}
            </div>
        </div>
    )
}

BarBlock.propTypes = {
    title: PropTypes.string.isRequired,
    width: PropTypes.number.isRequired,
    count: PropTypes.number.isRequired
}

export default BarBlock



// WEBPACK FOOTER //
// ./resources/js/components/BarBlock.js